// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + ({"678":"component---src-pages-index-js","883":"component---src-pages-404-js"}[chunkId] || chunkId) + "-" + {"678":"604fc804a01da9f438e7","883":"b81f42a82a84ead05155","954":"4cb85dba2e8ad570f151"}[chunkId] + ".js";
};